/**
 * GitHub auth helpers for sandbox commands.
 *
 * Config-file syncing into sandboxes was removed (ADR-13). GitHub auth is
 * passed to sandboxes as the GH_TOKEN env var, read from the local gh CLI.
 */

/**
 * Get GitHub token from local gh CLI
 */
export async function getGitHubToken(): Promise<string | undefined> {
  const { runOutput } = await import('../utils/exec.js');
  try {
    const token = await runOutput('gh auth token');
    return token || undefined;
  } catch {
    return undefined;
  }
}
